<template>
  <div class="card rounded-corner">
    <div class="card-body p-0 log-entries">
      <template v-if="logEntries?.data?.length">
        <div v-for="(logEntry, key) in logEntries.data" :key="key">
          <div v-if="logEntry.properties">
            <component
              :is="logEntryComponent(logEntry)"
              :log-entry="logEntry"
              :meta="meta"
              :resource-type="resourceType"
            ></component>
          </div>
        </div>
      </template>

      <div v-if="!logEntries.data" class="card log-entry">
        <div class="card-title p-2 m-0">
          <i class="bi bi-x-circle-fill text-danger"></i>
          <span class="text-primary ps-2">
            Logging für <code>{{ resourceType }}</code> nicht aktiviert.
          </span>
        </div>
      </div>
      <div v-if="logEntries.data && (!logEntries.data.length || !logEntries.data[0].properties)" class="card log-entry">
        <div class="card-title p-2 m-0">Bisher keine Log-Einträge vorhanden.</div>
      </div>
    </div>
  </div>
</template>

<script>
import PresentationField from '@kanrisha/components/Presentation/PresentationField';
import { defineAsyncComponent } from 'vue';

export default {
  components: {
    PresentationField,
  },
  props: {
    meta: {
      type: Object,
      default: () => {},
    },
    logEntries: {
      type: Object,
      default: () => {},
    },
    resourceType: { type: String, default: '' },
  },
  emits: ['addToast'],
  setup() {
    const logEntryComponent = (logEntry) => {
      try {
        require('@kanrisha/components/AppEventLog/Events/' + logEntry.component + '.vue');

        return defineAsyncComponent(() =>
          import('@kanrisha/components/AppEventLog/Events/' + logEntry.component + '.vue')
        );
      } catch (e) {
        //
      }
    };

    return {
      logEntryComponent,
    };
  },
};
</script>
